import { PaymentFormData } from "@/components/Payment/PaymentForm/interfaces/PaymentFormData.ts";
import { HolderFormData } from "@/pages/ReservationHolderInformation/HolderFormData.ts";
import { useMemo } from "react";

export const useIsFormValid = (holderFormData: HolderFormData, paymentFormData: PaymentFormData) => {
  const { isValid: holderFormValid } = holderFormData;
  const { isValid: paymentFormValid, formEnabled: paymentFormEnabled } = paymentFormData;

  const isFullFormValid = useMemo(() => {
    return paymentFormEnabled ? holderFormValid && paymentFormValid : holderFormValid;
  }, [holderFormValid, paymentFormEnabled, paymentFormValid]);

  const isHolderFormValid = useMemo(() => {
    return holderFormValid;
  }, [holderFormValid]);

  return {
    isFullFormValid,
    isHolderFormValid,
  };
};
